<div class="d-flex justify-content-between notMobile">
    <div class="flex-item m-2">
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="goHome();">
            <i class="fas fa-home me-2"></i> Home
        </p-button>
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="loadSearch();">
            <i class="fa-solid fa-upload me-2"></i> Load Saved Search
        </p-button>
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="goAdvSearch();">
            <i class="fa-brands fa-searchengin me-2"></i> Advanced Search
        </p-button>
    </div>
    <diV class="flex-item m-2">
        <app-search-simple-form [searchForm]="searchForm"></app-search-simple-form>
    </diV>
    <diV class="flex-item m-2">
        <p-splitbutton label="Help & Info" icon="fas fa-circle-question" [model]="helpInfoItems" size="small"  id="helpBtn" severity="secondary"/>
    </diV>
</div>
<div class="forMobile"><p-menubar [model]="navItems"></p-menubar></div>
<app-search-load-dialog [loadSearchVisible]="loadSearchVisible" (loadSearch)="executeLoadSearch($event)"
  (closeLoadSearch)="closeLoadSearch();"></app-search-load-dialog>